import Immutable from 'immutable';

export const createAuthUserReducer = () => {
    return (state = Immutable.Map(), action) => {
        switch (action.type) {
            // Step 1: Store authorization code from Auth0 redirect
            case 'SET_AUTH0_CODE': {
                return state.set('code', action.value);
            }

            // Step 2: Store token from token exchange
            case 'SET_AUTH0_TOKEN': {
                return state.merge(Immutable.Map({
                    token: action.token,
                    refreshToken: action.refreshToken,
                    expiresIn: action.expiresIn,
                    idToken: action.idToken
                }));
            }

            // Generic user update (primary action)
            case 'SET_AUTH_USER': {
                return state.merge(Immutable.Map({
                    code: action.code || null,
                    token: action.token || null,
                    timestamp: action.timestamp || new Date().toISOString()
                }));
            }

            // Store authentication errors
            case 'SET_AUTH0_ERROR': {
                return state.merge(Immutable.Map({
                    error: action.error,
                    severity: action.severity
                }));
            }

            default: {
                return state;
            }
        }
    };
};

export default createAuthUserReducer;
